import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { InputGroup, FormControl } from 'react-bootstrap'
import { FaIcon } from '../../../../shared/components'

class CalendarInputComponent extends Component {
  constructor(props){
    super(props)
  }
  
  render() {
    return (
      <InputGroup onClick={ this.props.onClick }>
        <FormControl value={ this.props.value } />
        <span className="input-group-addon" style={{ background: 'white', display: 'table-cell' }}>
          <FaIcon icon="calendar-alt" style={{ color: '#4F4F4F' }} />
        </span>
      </InputGroup>
    )
  }
}

CalendarInputComponent.propTypes = {
  onClick: PropTypes.func,
  value: PropTypes.string,
}

export default CalendarInputComponent
